<template>
  <div>
    <div
      class="text-6 gray--text d-flex align-center clickable"
      @click="
        $router.push({
          name: 'StakeProjectDetails',
          params: { projectName: $route.params.projectName },
        })
      "
    >
      <v-icon small class="gray--text">mdi-chevron-left</v-icon>
      <span class="ml-1">Go Back</span>
    </div>
    <div class="mt-8">
      <div class="d-flex align-center">
        <img
          v-if="$vuetify.theme.dark"
          :src="currentProject.logoSmallDark || currentProject.logoSmall"
          height="36"
          width="36"
        />
        <img v-else :src="currentProject.logoSmall" height="36" width="36" />
        <div class="heading-4 ml-6">{{ currentProject.text }}</div>
        <div class="d-flex">
          <v-divider vertical class="mx-6"></v-divider>
          <div class="heading-4">Proposals</div>
        </div>
      </div>
    </div>
    <div class="mt-10">
      <proposal-table :proposalItems="proposalItems" />
    </div>
    <c-loading v-if="proposals.fetching" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProposalTable from "./ProposalTable.vue";

export default {
  components: {
    ProposalTable,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      proposals: "staking/tendermint/proposals",
    }),
    proposalItems() {
      return this.proposals.result || [];
    },
  },
  mounted() {
    this.$store.dispatch("staking/tendermint/fetchProposalsInfo");
  },
};
</script>
